import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const location = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getFreeroomUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_FREEROOM
  },
  getClientId () {
    return store.getters['Client/clientId']
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getClientIdFreeroom() {
    return store.getters['Client/clientIdFreeroom']
  },
  getLocations () {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations`)
  },
  getLocationsGroupedBySite (clientId) {
    const client = clientId? clientId : this.getClientIdDesk4me()
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${client}/sites/locations`)
  },
  getInitialLocationsGroupedBySite () {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/sites/locations`)
  },
  getInitialLocationsFreeroom () {
    return Axios.get(`${this.getFreeroomUrl()}/api/public/clients/${this.getClientIdFreeroom()}/locations`)
  },
  addLocations (location) {
    return Axios.post(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/sites/${location.siteId}/locations`, location)
  },
  editLocations (location) {
    return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/sites/${location.siteId}/locations/${location.id}`, location)
  },
  getLocationMap(locationId){
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/map/svgWithDeskNames`)
  },
  getLocationDevices(locationId) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/devices`)
  },
  saveLocationDevices (locationId, devicesIds, blockAccessUponPriorBooking) {
    const body = { locationId: locationId, devices: devicesIds, blockAccessUponPriorBooking: blockAccessUponPriorBooking }
    return Axios.post(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/devices`, body)
  },
  activateLocal (locationId) {
    return Axios.patch(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/activate`, {
      ignoreGlobalCatch: true,
    })
  },
  deactivateLocal (locationId, cancelFutureBookings) {
    return Axios.patch(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/deactivate?cancelFutureBookings=${cancelFutureBookings}`, {
      ignoreGlobalCatch: true,
    })
  },
  getIntegration (locationId) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/integrations`)
  },
  saveIntegration (locationId, integration) {
    return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/integrations`, integration)
  },
  getSensorsWithLocation () {
    return Axios.get(`/api/v1/clients/${this.getClientIdDesk4me()}/locations/sensors`)
  }
}

export default location
